import React, { Component } from "react";
import { connect } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import "../assets/css/sigPad.css";

/** Utils */
import { buttonStyles } from "../assets/js/constants";

/** Component */
import { SignatureComponent } from "../component/SignatureComponent";

/** Actions */
import * as actions from "../action";

class SignatureContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signatureName: "",
      sigPad: {},
      typePadDisplay: "none",
      sigPadDisplay: "block",
      base64DataFromLink: "",
      btnTypeStyle: buttonStyles.default,
      btnDrawStyle: buttonStyles.success,
    };

    /** Set the ref of SignatureCanvas component in sigPad var  */
    this.sigPad = null;
  }

  componentDidMount() {
    this.clearCanvasType();
    this.clearCanvasSigPad();
  }
  /**
   * Catch all errors in this component
   * @param error
   * @param errorInfo
   */
  componentDidCatch(error, errorInfo) {
    console.log("Error: ", error, "ErrorInfo: ", errorInfo);
  }

  /** Set canvas and input values */
  onChange = (event) => {
    this.setState({
      signatureName: event.target.value,
    });

    // Write in canvas
    let canvas = document.getElementById("typeCanvas");
    let context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = `italic 40px mr dafoe`;
    context.fillText(event.target.value, 30, 90);

    const signatureNameCanvas = canvas.toDataURL("image/png");
    // Update store values
    this.props.setSignType(signatureNameCanvas);
    this.props.setIsSignatureEmpty(false);
  };

  /** Callback that will be called when a stroke ends
   *  Set values in reducer
   */
  onEndSignature = () => {
    const signatureImageBase64 = this.sigPad
      .getTrimmedCanvas()
      .toDataURL("image/png");
    if (!this.sigPad.isEmpty(signatureImageBase64)) {
      // Update store values
      this.props.setSignPad(signatureImageBase64);
      this.props.setIsSignatureEmpty(false);
    }
  };

  /** Hide SigPad * Show Type */
  onHiddenSigPad = () => {
    this.setState({
      typePadDisplay: "block",
      sigPadDisplay: "none",
      btnTypeStyle: buttonStyles.success,
      btnDrawStyle: buttonStyles.default,
    });

    // Clear sigPad canvas
    this.clearCanvasSigPad();
  };

  /** Hide Type * Show SigPad */
  onHiddenType = () => {
    this.setState({
      typePadDisplay: "none",
      sigPadDisplay: "block",
      signatureName: "",
      btnTypeStyle: buttonStyles.default,
      btnDrawStyle: buttonStyles.success,
    });

    // Clear Type canvas
    this.clearCanvasType();
  };

  /** Clear signature values */
  onClearSignature = () => {
    this.setState({
      typePadDisplay: "none",
      sigPadDisplay: "block",
      signatureName: "",
      btnTypeStyle: buttonStyles.default,
      btnDrawStyle: buttonStyles.success,
    });

    this.clearCanvasType();
    this.clearCanvasSigPad();

    // Update store values
    this.props.setIsSignatureEmpty(true);
  };

  /** Clear Canvas Type */
  clearCanvasSigPad = () => {
    if (this.sigPad) {
      this.sigPad.clear();
    } else {
      // console.log('Refresh Page and try again');
    }
    this.props.setSignPad(null);
  };

  /** Clear Canvas Type */
  clearCanvasType = () => {
    // Clear typeCanvas
    let canvas = document.getElementById("typeCanvas");
    let context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = `italic 40px mr dafoe`;
    context.fillText("", 10, 50);

    this.props.setSignType(null);
  };

  render() {
    return (
      <SignatureComponent
        signatureName={this.state.signatureName} // Signature Text
        onChangeSignatureName={this.onChange} // Input field Signature Text
        typePadDisplay={this.state.typePadDisplay} // Show or hide typing signature
        sigPadDisplay={this.state.sigPadDisplay} // Show or hide signature
        onHiddenSigPad={this.onHiddenSigPad} // Func to hide sigPad
        onHiddenType={this.onHiddenType} // Func to hide Type
        clearSignature={this.onClearSignature} // Func to clear type and sigPad
        btnTypeStyle={this.state.btnTypeStyle}
        btnDrawStyle={this.state.btnDrawStyle}
        signatureComponent={
          <SignatureCanvas
            canvasProps={{
              className: "sigCanvas",
            }}
            ref={(ref) => (this.sigPad = ref)}
            onEnd={this.onEndSignature}
            clearOnResize={false}
          />
        }
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSignPad: (signatureBase64) =>
      dispatch(actions.setSignPad(signatureBase64)),
    setSignType: (signatureBase64) =>
      dispatch(actions.setSignType(signatureBase64)),
    setIsSignatureEmpty: (isEmpty) =>
      dispatch(actions.setIsSignatureEmpty(isEmpty)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignatureContainer);



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/container/SignatureContainer.js